/**
 * Social Links Data
 * Social media and contact links with icons and colors
 */

import { FaEnvelope, FaLinkedin, FaGithub, FaPhone } from 'react-icons/fa';
import type { SocialLink } from '@/types';
import { personalInfo } from './personal';

export const socialLinks: SocialLink[] = [
  { 
    name: "Email", 
    icon: FaEnvelope, 
    url: `mailto:${personalInfo.email}`, 
    color: "hover:text-red-500" 
  },
  { 
    name: "LinkedIn", 
    icon: FaLinkedin, 
    url: personalInfo.linkedin, 
    color: "hover:text-blue-600" 
  },
  { 
    name: "GitHub", 
    icon: FaGithub, 
    url: personalInfo.github, 
    color: "hover:text-gray-400" 
  },
  { 
    name: "Phone", 
    icon: FaPhone, 
    url: `tel:${personalInfo.phone}`, 
    color: "hover:text-green-500" 
  }
];

